import {Provider} from "./provider";
import {log} from "../../util/log";

export class GPTProvider extends Provider {
    /* STATIC */

    /* INSTANCE */
    override configure(value: boolean) {
        if ((window as any)['dataLayer']) {
            (window as any)['dataLayer'].push('consent', 'update', {
                'ad_storage': value ? 'granted' : 'denied',
                'ad_user_data': value ? 'granted' : 'denied',
                'ad_personalization': value ? 'granted' : 'denied',
                'analytics_storage': value ? 'granted' : 'denied'
            });
        } else {
            log.debug('dataLayer not found');
        }
    }
}
